export default class TicketService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  getTickets (query = {}) {
    return new Promise((resolve, reject) => {
      this.$http.get('tickets', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data.data || data)
        })
        .catch(reject)
    })
  }

  getTicketsPaginated (query = {}) {
    return new Promise((resolve, reject) => {
      this.$http.get('tickets/paginated', { params: query })
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }

  getTicket (id) {
    return new Promise((resolve, reject) => {
      this.$http.get(`tickets/${id}`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createTicket (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('tickets/store', data)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updateTicket (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`tickets/update/${id}`, data)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  deleteTicket (id) {
    return new Promise((resolve, reject) => {
      this.$http.post(`tickets/delete/${id}`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  revokeTicket (id) {
    return new Promise((resolve, reject) => {
      this.$http.post(`tickets/revoke/${id}`)
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  printTickets (ticketIds) {
    return new Promise((resolve, reject) => {
      // For now, we'll print tickets one by one since the backend expects individual ticket IDs
      if (Array.isArray(ticketIds)) {
        // If multiple tickets, we'll handle them individually
        const promises = ticketIds.map(id => this.printTicket(id))
        Promise.all(promises)
          .then(results => resolve(results))
          .catch(reject)
      } else {
        this.printTicket(ticketIds)
          .then(resolve)
          .catch(reject)
      }
    })
  }

  printTicket (ticketId) {
    return new Promise((resolve, reject) => {
      this.$http.get(`print/ticket/${ticketId}`)
        .then(res => res.data)
        .then(data => {
          resolve(data)
        })
        .catch(reject)
    })
  }
}
